module.exports = __webpack_public_path__ + "static/media/logo_texto.ecbac263.svg";